/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    export interface ISearchNodeModalScope extends ng.IScope {
        networkNodes: Models.INetworkNode[];
        modalClose: () => void;
        modalSave: (selectedNode: Models.INetworkNode) => void;
    }

    /**
     * DeleteModalController class
     */
    export class SearchNodeModalController {
        public static templateURL: string = "decorators/modals/search-node-modal.html";
        public static ID: string = "#id-search-node-modal";
        public static $name: string = "searchNodeModalController";
        public static $inject: string[] = ['$scope', 'close', 'networkNodes'];

        private $scope: ISearchNodeModalScope;
        private close: (parameters: ngModal.ICloseParameters) => void;

        /**
         * Constructor
         */
        constructor($scope: ISearchNodeModalScope,
                    close: (parameters: ngModal.ICloseParameters) => void,
                    networkNodes: Models.INetworkNode[]) {
            this.$scope = $scope;
            this.$scope.networkNodes = networkNodes;
            this.close = close;

            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.$scope.modalSave = (networkNode: Models.INetworkNode): void => {
                this.close(networkNode);
            };

        }
    }
}
